<template>
  <div class="home">
    <div v-if="isLoadingData">
        <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_nvskuoaw.json"  background="transparent" class="customProgress"  speed="1"  style="width: 300px; height: 300px;"    autoplay></lottie-player>
    </div>
    <!-- <ProgressSpinner v-if="isLoadingData"/> -->
    <div v-if="isLoadingData == false">
        <Toast /> 
        <Header :headerData = "headerData" />
        <InformationStudents :informationsData = "informationsData" title="I. THÔNG TIN HỌC SINH"/>
        <SummaryLearning :summaryLearning="summaryLearning" :noteViThu="noteViThu" title="II. TỔNG KẾT HỌC TẬP (Báo cáo nhanh đến thời điểm hiện tại)"/>
        <TableSchoolFees :tableSchoolFeesData="tableSchoolFeesData" :unpaidSchoolFeeData="unpaidSchoolFeeData" title="III. CHUYÊN CẦN VÀ HỌC PHÍ" v-if="showSection !== '' && showSection=='3'"/>
        <TableSchoolFees :tableSchoolFeesData="tableSchoolFeesData" :unpaidSchoolFeeData="unpaidSchoolFeeData" title="III. CHUYÊN CẦN VÀ HỌC PHÍ" v-else-if="showSection == ''" />
        
        <ResultLearning :resultLearningData="resultLearningData" :noteViThu="noteViThu" title="IV. KẾT QUẢ HỌC TẬP" v-if="showSection !== '' && showSection=='4'"/>
        <ResultLearning :resultLearningData="resultLearningData" :noteViThu="noteViThu" title="IV. KẾT QUẢ HỌC TẬP" v-else-if="showSection == ''" />

        <ResultSummary :resultSummaryData="resultSummaryData" :noteViThu="noteViThu" title="V. KẾT QUẢ TỔNG HỢP" v-if="showSection !== '' && showSection=='5'"/>
        <ResultSummary :resultSummaryData="resultSummaryData" :noteViThu="noteViThu" title="V. KẾT QUẢ TỔNG HỢP" v-else-if="showSection == ''" />

        <TeacherComments :teacherCommentsData = "teacherCommentsData" :noteViThu="noteViThu" title="VI. NHẬN XÉT CỦA GIÁO VIÊN" v-if="showSection !== '' && showSection=='6'"/>
        <TeacherComments :teacherCommentsData = "teacherCommentsData" :noteViThu="noteViThu" title="VI. NHẬN XÉT CỦA GIÁO VIÊN" v-else-if="showSection == ''" />
        <footer>Một sản phẩm của MEGAEDU</footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import InformationStudents from './InformationStudents.vue'
import TableSchoolFees from './TableSchoolFees.vue'
import ResultLearning from './ResultLearning.vue'
import ResultSummary from './ResultSummary.vue'
import TeacherComments from './TeacherComments.vue'
import SummaryLearning from './SummaryLearning.vue'

export default {
  name: 'Homepage',
  components: {Header, InformationStudents, TableSchoolFees, ResultLearning, ResultSummary,TeacherComments, SummaryLearning},
  data() {
    return {
      valueProgress: 0,
      headerData: {
          centerNameClass:'',
          codeClass: '',
          calendarLearning:'',
          teacherName:'',
          logo:''
      },
      informationsData: {
          studentName:'',
          classAtSchool:'',
          studentPhone:'',
          parentPhone:'',
          parentName:'',
          studentCode:'',
          studentBirth:'',
          code:'',
          schoolName:'',
          studentPicture:''
      },
      summaryLearning: {
          averageMark:null,
          diligentMark:null,
          totalMark:null,
          rank:null
      },
      tableSchoolFeesData:[],
      unpaidSchoolFeeData: '',
      resultLearningData:[],
      resultSummaryData:[],
      teacherCommentsData:[],
      isLoadingData: false,
      showSection: '',
      noteViThu: ''
    }
  },
  watch: {
  },
  created() {
        if (Object.keys(this.$route.query).length != 0 && ('section' in this.$route.query)) {
            this.showSection = this.$route.query.section
        } else {
            this.showSection = ''
        }
        this.getData()
    },
  methods: {
    getData(){
        this.isLoadingData = true
        // toast is loading data
        this.$toast.add({
              severity:'info', 
              summary: 'Message', 
              detail:'Dữ liệu đang được tải', life: 3000
            })
        // Get router
        let senderID = this.$route.params.senderID

        // pass data to bodyForm
        let bodyFormData = {
            // "event_name":"user_send_text", 
            //     "message": {"text": "#phieulienlac"}, 
            //     "sender": {"id": senderID}
            mode:'phieulienlac',
            userId:senderID
        }
        
        // let bodyFormData = new FormData();
        //   bodyFormData.append('mode', "phieulienlac");
        //   bodyFormData.append('userId', "9085650962571596015");
        this.axios({
          method: "post",
          url: this.$urlAPI,
          data: JSON.stringify(bodyFormData),
          headers: {
              'Content-Type':'application/json'
          },
          auth: this.$auth,
        })
        .then(response => {
        //   let data = response.data
          if (response.data.status == 'failed') {
            this.$toast.add({
              severity:'error', 
              summary: 'Error Message', 
              detail:'Sender id have not exists', life: 3000
            })
          } else {
              this.$toast.add({
              severity:'success', 
              summary: 'Message', 
              detail:'Loading data has success', life: 3000
            })
            let data = response.data
            if (data != '') {
                this.noteViThu = data.Note === "Đầy đủ" ? true : false
                this.makeHeader(data)
                this.makeInformationStudents(data)
                this.makeSummaryLearning(data)
                this.makeTableSchoolFees(data)
                this.makeResultLearning(data)
                this.makeresultSummaryData(data)
                this.makeTeacherComments(data)
            }
          }
        }).catch(err => 
            {
              this.$toast.add({
                  severity:'error', 
                  summary: 'Error Message', 
                  detail:'Err' + err, life: 3000
              })
            }
        ).finally(() => {
            this.isLoadingData = false
        })
    },
    makeHeader(data){
        // let arrTeacherName = data['Giáo viên'] !='' ? data['Giáo viên'] : [];
        // let nameConcate = [];
        // if(arrTeacherName.length > 0) {
        //     for (let index = 0; index < arrTeacherName.length; index++) {
        //         const element = arrTeacherName[index];
        //         nameConcate.push(element['Họ và tên'])
        //     }
        // }
        this.headerData = {
            centerName:data['Trung tâm'] !='' ? data['Trung tâm'] : '',
            centerNameClass:data['Lớp ở trung tâm'] !='' ? data['Lớp ở trung tâm'] : '',
            codeClass: data['Mã lớp'] !='' ? data['Mã lớp'] : '',
            calendarLearning:data['Lịch học'] !='' ? data['Lịch học'] : '',
            teacherName:data['Giáo viên'] !='' ? data['Giáo viên'] : '',
            logo:data['Logo'] !='' ? data['Logo'] : ''
        }
    },
    makeInformationStudents(data){
        this.informationsData = {
          studentName: data['Họ và tên'] !='' ? data['Họ và tên'] : '',
          classAtSchool: data['Lớp ở trường'] !='' ? data['Lớp ở trường'] : '',
          studentPhone: data['Điện thoại'] !='' ? data['Điện thoại'] : '',
          parentPhone: data['Điện thoại phụ huynh'] !='' ? data['Điện thoại phụ huynh'] : '',
          parentName: data['Tên phụ huynh'] !='' ? data['Tên phụ huynh'] : '',
          studentCode: data['Mã học viên'] !='' ? data['Mã học viên'] : '',
          studentBirth: data['Ngày sinh'] !='' ? data['Ngày sinh'] : '',
          code: data['SBD'] !='' ? data['SBD'] : '',
          schoolName: data['Trường'] !='' ? data['Trường'] : '',
          studentPicture: data['Ảnh hồ sơ'] !='' ? data['Ảnh hồ sơ'] : ''
      }
    },
    makeSummaryLearning(data){
        this.summaryLearning = {
          averageMark:data['Điểm trung bình'] !='' ? data['Điểm trung bình'] : '',
          diligentMark:data['Điểm chuyên cần'] !='' ? data['Điểm chuyên cần'] : '',
          totalMark:data['Điểm tổng kết'] !='' ? data['Điểm tổng kết'] : '',
          rank: data['Xếp hạng'] !='' ? data['Xếp hạng'] : ''
      }
    },
    makeTableSchoolFees(data){
        this.tableSchoolFeesData = data['Điểm danh'] !='' ? data['Điểm danh'] : ''
        this.unpaidSchoolFeeData = data['Học phí chưa đóng (Tháng)'] != '' ? data['Học phí chưa đóng (Tháng)'] : '';
    },
    makeResultLearning(data){
        let course1 = data['Kết quả HKI'] !='' ? data['Kết quả HKI'] : ''
        let course2 = data['Kết quả HKII'] !='' ? data['Kết quả HKII'] : ''
        this.resultLearningData.push(course1)
        this.resultLearningData.push(course2)
    },
    makeresultSummaryData(data){
        this.resultSummaryData = data['Kết quả tổng hợp'] !='' ? data['Kết quả tổng hợp'] : ''
    },
    makeTeacherComments(data){
        this.teacherCommentsData = data['Nhận xét'] !='' ? data['Nhận xét'] : ''
    }
  }
}
</script>

<style>
body{
    padding: 0;
    margin: 0;
}
.customProgress{
    position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.flex-container {
    display: flex;
    flex-wrap: wrap;
  }
.logo img{
    max-width: 55%;
}
.name,
.title{
    margin-top:0;
    margin-bottom:0;
    text-align: center;
}
.name{
    background-color: #FFE599;
}
.background-sort-blue-color{
    background-color: #B7E2CD;
}
.background-blue-color{
    background-color: #CFE2F3;
}
.color-blue{
    color: #415C8E;
}
.background-pink-color{
    background-color: #FCE9D9;
}
.background-red-color{
    background-color: #FD0000;
}
.color-yeallow{
    color: #EAEB03;
}
.background-yeallow-color{
    background-color: #EAEB03;
}
.color-red{
    color: #FD0000;
}
header .box{
    display: flex;
    flex-wrap: wrap;
    margin-right: 15px;
    margin-left: 15px;
}
header .box .item{
    display: flex;
    align-items: baseline;
}
header .box .item label{
    flex: 30%;
    text-align: right;
}
header .box .item h3{
    flex: 70%;
    padding-left: 15px;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    text-align: left;
}

/* information-student */
.title-section {
    padding-left: 15px;
    background-color: #EAF1DD;
    color: #FF0000;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: left;
    margin-bottom: 0px;
}
.information-student .box{
    display: flex;
    align-items: center;
    /* padding-left: 10%; */
    margin-left: 15px;
    margin-right: 15px;
}
.information-student .box .item{
    display: flex;
    align-items: baseline;
}
.information-student .box .picture img{
    margin-top: 5px;
    width: 100%;
}
.information-student .box .item label{
    flex: 40%;
    text-align: right;
}
.information-student .box .item h3{
    flex: 60%;
    padding-left: 5px;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    text-align: left;
}


/* Table */
.table-school-fees{
    overflow: scroll;
    position: relative;
    width: 100%;
    display: block;
}
.table-school-fees table{
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    overflow: scroll;
    margin-bottom: 10px;
    min-width: 600px;
    table-layout: fixed;
  }
  
.table-school-fees table td, 
.table-school-fees table th {
    border: 3px solid #000;
    /* text-align: left; */
    /* padding: 5px; */
    /* width: 50px; */
}
.table-school-fees table td{
    width: 50px;
}
.table-school-fees .title-section{
    min-width: 600px;
}
/* Section  result-learning*/
.result-learning .box{
    overflow: auto;
}
.result-learning .box table{
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  
.result-learning .box table td,
.result-learning .box table th {
    border: 3px solid #000;
    text-align: center;
    padding: 5px;
}
/* Section result-summary  */
.result-summary .box-diagram{
    min-width: 500px
}
.result-summary .box-content .box-table table{
    font-family: arial, sans-serif;
    height: 100%;
    width: 100%;
    border-collapse: collapse;
}
.result-summary .box-content .box-table table td,
.result-summary .box-content .box-table table th {
    border: 3px solid #000;
    text-align: center;
    padding: 5px;
}

/* teacher-comments */
.teacher-comments table{
    width: 100%;
    font-family: arial, sans-serif;
    border-collapse: collapse;
}
.teacher-comments table td,
.teacher-comments table th {
    border: 3px solid #000;
    text-align: center;
    padding: 5px;
}
/* Code footer */
footer{
    margin-top: 50px;
    background: teal;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
}

/* Code responive page */
@media only screen and (max-width : 400px) {
/* Styles */
    .logo img{
        max-width: 40%;
        margin: 0 auto;
    }
    .result-summary .box-diagram{
        min-width: 650px;
    }
}
@media only screen and (max-width : 575px) {
    .logo img{
        max-width: 35%;
        margin: 0 auto;
    }
    .information-student .box .picture img{
        width: 30%;
        margin: 0 auto;
    }
}
@media only screen and (min-width : 576px) {
    .logo img{
        max-width: 70%;
    }

}
</style>